import React, { useState } from "react";
import "../styles/program-card.css";
import ImageLightbox from "./ImageLightbox";

export default function ProgramCard({ program }) {

  const [open, setOpen] = useState(false);

  // Safety check
  if (!program) return null;

  // Support both title and name
  const title = program.name || program.title || "Program";

  // Support both description fields
  const description =
    program.short_description ||
    program.description ||
    "";

  // Support single image OR multiple images
  let images = [];

  if (program.images && Array.isArray(program.images)) {
    images = program.images;
  } else if (program.image) {
    images = [program.image];
  }

  const mainImage = images.length > 0 ? images[0] : null;

  return (
    <>
      <div className="program-card">

        {/* Program Image */}
        {mainImage && (
          <div className="program-image">
            <img
              src={mainImage}
              alt={title}
              onClick={() => setOpen(true)}
            />
          </div>
        )}

        {/* Program Content */}
        <div className="program-content">

          <h3 className="program-title">
            {title}
          </h3>

          {description && (
            <p className="program-description">
              {description}
            </p>
          )}

          {program.location && (
            <p className="program-location">
              📍 {program.location}
            </p>
          )}

          {images.length > 0 && (
            <button
              className="view-gallery-btn"
              onClick={() => setOpen(true)}
            >
              View Photos
            </button>
          )}

        </div>
      </div>

      {/* Image Popup Gallery */}
      {images.length > 0 && (
        <ImageLightbox
          images={images}
          open={open}
          setOpen={setOpen}
        />
      )}
    </>
  );
}